import { TextField } from "@mui/material";
import { ReactComponent as SearchIcon } from "../../assets/SearchIcon.svg";

export default function Input({
  onChange,
  placeholder,
  errorMessage,
  value,
  style={},
  disabled=false,
  showSearchIcon=false,
  height=33,
  width=210
}: {
  onChange: (arg: string) => void;
  placeholder?: string;
  errorMessage?: string;
  value?: string;
  style?: any;
  disabled?: boolean;
  showSearchIcon?: boolean;
  height?: number;
  width?: number;
}) {

//   .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {
//     height: 33px !important;
// }
  return (
    <TextField
      value={value}
      disabled={disabled}
      error={!!errorMessage}
      helperText={errorMessage}
      sx={{
        minWidth: width,
        ...style,
        "& .MuiInputBase-root": {
          height: height,
          fontFamily: "Lato, sans-serif",
          display: "flex",
          alignItems: "center",
        },
        "& MuiInputLabel-root": {
          top: "-7px",
        },
      }}
      id="outlined-basic"
      label={placeholder}
      variant="outlined"
      onChange={(e: any) => onChange(e.target.value)}
    >
      {showSearchIcon && <SearchIcon style={{ marginRight: 10 }} />}
    </TextField>
  );
}
